import React from 'react'
import Marquee from "react-fast-marquee";

export default function Section8() {
  const testimonials1 = [
    {
      text: "At GoalDex, we've blended AI, blockchain, & advanced player analytics to create a powerful platform.",
      img: "/assets/others/Marq-1.svg",
      name: "Dinesh",
      role: "Lead Blockchain Developer",
    },

    {
      text: "Blockchain at GoalDex  is all about creating a transparent & verifiable player journey.",
      img: "/assets/others/Marq-2.svg",
      name: "Manikandan",
      role: "Head Developer",
    },
    {
      text: "We've developed a system which is futuristic, fast, scalable and powerful for clubs, players and fans.",
      img: "/assets/others/Marq-3.svg",
      name: "Sushwant",
      role: "Lead Designer",
    },
    {
      text: "Every interaction is designed to feel like a winning goal—sharp, and impactful like a brilliant play on the pitch.",
      img: "/assets/others/Marq-4.svg",
      name: "Rajmohan",
      role: "Project Manager",
    },
  ];
  const testimonials = [
    {
      text: "With every feature, we focus on innovation, precision to our users with every sprint.",
      img: "/assets/others/Marq-6.svg",
      name: "Adlene Jenitta",
      role: "Project Lead",
    },

    {
      text: "We're shaping the future of football.—and we’re making sure GoalDex always stays ahead of the curve.",
      img: "/assets/others/Marq-6.svg",
      name: "Sathish",
      role: "Lead Backend Developer",
    },
    {
      text: "Smooth UI, fast load times—every user, from player to club, feels at the top of their game.",
      img: "/assets/others/Marq-5.svg",
      name: "Anup Kumar",
      role: "Chief Technology Officer",
    },
  ];

  return (
    <div className='min-h-screen bg-[#0E081B]/30 flex items-center'>
      <div className='w-[100%]'>
        {/*
        <div className='flex justify-center py-5'>
          <button className='px-10 py-2 rounded-full font-bold border border-white bg-black text-[#A880FF]'>TESTIMONIALS</button>
        </div>*/}
        <div className='flex flex-col gap-3 relative'>
          <p className='text-center font-medium text-white text-3xl lg:text-4xl 2xl:text-5xl'>Team Talk: The Minds Behind the Game</p>
          <p className='text-center  text-white '>Meet the brilliant team powering GoalDex with cutting-edge tech and football passion.</p>
        </div>

        <div>

          <Marquee className="mt-5" direction="left" speed={80} pauseOnHover>
            <div className="flex items-center">
              {[...testimonials, ...testimonials].map((item, index) => (
                <div
                  key={index}
                  className="w-[350px] bg-white rounded-xl mx-3 px-5 py-5 shadow-lg"
                >
                  <p className="text-black text-left">{item.text}</p>
                  <div className="flex items-center gap-4 mt-4">
                    <img src={item.img} alt={item.name} className="w-10 h-10" />
                    <div>
                      <p className="text-[#5C1FE2] font-bold text-lg">{item.name}</p>
                      <p className="text-[#5C1FE2] font-bold text-sm">{item.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Marquee>
          <Marquee className="mt-5" direction="right" speed={80} pauseOnHover>
            <div className="flex items-center">
              {[...testimonials1, ...testimonials1].map((item, index) => (
                <div
                  key={index}
                  className="w-[350px] bg-white rounded-xl mx-3 px-5 py-5 shadow-lg"
                >
                  <p className="text-black text-left">{item.text}</p>
                  <div className="flex items-center gap-4 mt-4">
                    <img src={item.img} alt={item.name} className="w-10 h-10" />
                    <div>
                      <p className="text-[#5C1FE2] font-bold text-lg">{item.name}</p>
                      <p className="text-[#5C1FE2] font-bold text-sm">{item.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Marquee>

        </div>
      </div>
    </div>
  )
}
